import { PromoCode } from '../types';
import { toQueryParams } from '../utils';
import { axiosInstance, endpoints } from '../utils/axios';

export async function getPromoCode(
  eventId: number,
  name: string,
  ticketsQuantity: number,
  ticketSettingIds?: number[]
): Promise<PromoCode> {
  const url = endpoints.promoCode.findByNameAndEventId(`${eventId}`, name);
  const response = await axiosInstance.get<PromoCode>(
    `${url}?${toQueryParams({ qty: ticketsQuantity, ticketSettingIds })}`
  );
  return response.data;
}
